'use client'

import 'client-only'
import { createTRPCReact } from '@trpc/react-query'
import { type AppRouter } from '../app/api/router'

export const trpc = createTRPCReact<AppRouter>()
